import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'overline', 'IconOverline', [["path",{"d":"M7 9v5a5 5 0 0 0 10 0v-5","key":"svg-0"}],["path",{"d":"M5 5h14","key":"svg-1"}]]);